import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getParameterGroup,
  getParameter,
  createParameterGroup,
  createParameter,
  getIdParameterGroup,
  getIdParameter,
  updateParameter,
  updateParameterGroup,
  getParameterGroupCode,
  // deleteById,
} from "./businessParameterAPI";

const initialState = {
  dataGroup: [],
  data: [],
  data2: [],
  data3: [],
  data4: [],
  data5: [],
  data6: [],
  data7: [],
  data8: [],
  dataIdParam: null,
  dataIdGroup: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
  dataGroupAreaFunc: [],
  dataGroupCountry: [],
  dataGroupPhoneType: [],
  dataGroupUom: [],
  dataGroup1: [],
  dataGroup2: [],
  dataGroup3: [],
};

export const fetchParameter = createAsyncThunk(
  "businessParameter/fetchParameter",
  async (payload) => {
    const response = await getParameter(payload);
    return response;
  }
);
export const fetchParameter2 = createAsyncThunk(
  "businessParameter/fetchParameter2",
  async (payload) => {
    const response = await getParameter(payload);
    return response;
  }
);
export const fetchParameter3 = createAsyncThunk(
  "businessParameter/fetchParameter3",
  async (payload) => {
    const response = await getParameter(payload);
    return response;
  }
);
export const fetchParameter4 = createAsyncThunk(
  "businessParameter/fetchParameter4",
  async (payload) => {
    const response = await getParameter(payload);
    return response;
  }
);
export const fetchParameter5 = createAsyncThunk(
  "businessParameter/fetchParameter5",
  async (payload) => {
    const response = await getParameter(payload);
    return response;
  }
);
export const fetchParameter6 = createAsyncThunk(
  "businessParameter/fetchParameter6",
  async (payload) => {
    const response = await getParameter(payload);
    return response;
  }
);
export const fetchParameter7 = createAsyncThunk(
  "businessParameter/fetchParameter7",
  async (payload) => {
    const response = await getParameter(payload);
    return response;
  }
);
export const fetchParameter8 = createAsyncThunk(
  "businessParameter/fetchParameter8",
  async (payload) => {
    const response = await getParameter(payload);
    return response;
  }
);
export const fetchGroup = createAsyncThunk(
  "businessParameter/fetchGroup",
  async (payload) => {
    const response = await getParameterGroup(payload);
    return response;
  }
);

export const addParameter = createAsyncThunk(
  "businessParameter/addParameter",
  async (payload) => {
    const response = await createParameter(payload);
    return response;
  }
);
export const addGroup = createAsyncThunk(
  "businessParameter/addGroup",
  async (payload) => {
    const response = await createParameterGroup(payload);
    return response;
  }
);

export const editParameter = createAsyncThunk(
  "businessParameter/editParameter",
  async (payload) => {
    const response = await updateParameter(payload);
    return response;
  }
);
export const editGroup = createAsyncThunk(
  "businessParameter/editGroup",
  async (payload) => {
    const response = await updateParameterGroup(payload);
    return response;
  }
);

export const fetchIdParameter = createAsyncThunk(
  "businessParameter/fetchIdParameter",
  async (id) => {
    const response = await getIdParameter(id);
    return response;
  }
);

export const fetchIdGroup = createAsyncThunk(
  "businessParameter/fetchIdGroup",
  async (id) => {
    const response = await getIdParameterGroup(id);
    return response;
  }
);

// export const removeById = createAsyncThunk(
//   "businessParameter/removeById",
//   async (payload) => {
//     const response = await deleteById(payload);
//     return response;
//   }
// );

export const fetchGroupAreaFunc = createAsyncThunk(
  "parGroup/fetchGroupAreaFunc",
  async (payload) => {
    const response = await getParameterGroupCode(payload);
    return response;
  }
);

export const fetchGroupCountry = createAsyncThunk(
  "parGroup/fetchGroupCountry",
  async (payload) => {
    const response = await getParameterGroupCode(payload);
    return response;
  }
);

export const fetchGroupPhoneType = createAsyncThunk(
  "parGroup/fetchGroupPhoneType",
  async (payload) => {
    const response = await getParameterGroupCode(payload);
    return response;
  }
);
export const fetchGroupUom = createAsyncThunk(
  "parGroup/fetchGroupUom",
  async (payload) => {
    const response = await getParameterGroupCode(payload);
    return response;
  }
);
export const fetchGroup1 = createAsyncThunk(
  "parGroup/fetchGroup1",
  async (payload) => {
    const response = await getParameterGroupCode(payload);
    return response;
  }
);
export const fetchGroup2 = createAsyncThunk(
  "parGroup/fetchGroup2",
  async (payload) => {
    const response = await getParameterGroupCode(payload);
    return response;
  }
);
export const fetchGroup3 = createAsyncThunk(
  "parGroup/fetchGroup3",
  async (payload) => {
    const response = await getParameterGroupCode(payload);
    return response;
  }
);

export const businessParameterSlice = createSlice({
  name: "businessParameter",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchParameter.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchParameter.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchParameter2.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchParameter2.fulfilled, (state, action) => {
        state.loading = false;
        state.data2 = action.payload.data.data;
      })
      .addCase(fetchParameter3.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchParameter3.fulfilled, (state, action) => {
        state.loading = false;
        state.data3 = action.payload.data.data;
      })
      .addCase(fetchParameter4.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchParameter4.fulfilled, (state, action) => {
        state.loading = false;
        state.data4 = action.payload.data.data;
      })
      .addCase(fetchParameter5.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchParameter5.fulfilled, (state, action) => {
        state.loading = false;
        state.data5 = action.payload.data.data;
      })
      .addCase(fetchParameter6.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchParameter6.fulfilled, (state, action) => {
        state.loading = false;
        state.data6 = action.payload.data.data;
      })
      .addCase(fetchGroup.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchParameter7.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchParameter7.fulfilled, (state, action) => {
        state.loading = false;
        state.data7 = action.payload.data.data;
      })
      .addCase(fetchParameter8.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchParameter8.fulfilled, (state, action) => {
        state.loading = false;
        state.data8 = action.payload.data.data;
      })
      .addCase(fetchGroup.fulfilled, (state, action) => {
        state.loading = false;
        state.dataGroup = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })

      .addCase(fetchIdParameter.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdParameter.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdGroup.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdGroup.fulfilled, (state, action) => {
        state.loading = false;
        state.dataIdGroup = action.payload.data.data;
      })
      .addCase(addParameter.pending, (state) => {
        state.loading = true;
      })
      .addCase(addParameter.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addGroup.pending, (state) => {
        state.loading = true;
      })
      .addCase(addGroup.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editParameter.pending, (state) => {
        state.loading = true;
      })
      .addCase(editParameter.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editGroup.pending, (state) => {
        state.loading = true;
      })
      .addCase(editGroup.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchGroupAreaFunc.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGroupAreaFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.dataGroupAreaFunc = action.payload.data.data;
      })
      .addCase(fetchGroupCountry.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGroupCountry.fulfilled, (state, action) => {
        state.loading = false;
        state.dataGroupCountry = action.payload.data.data;
      })
      .addCase(fetchGroupPhoneType.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGroupPhoneType.fulfilled, (state, action) => {
        state.loading = false;
        state.dataGroupPhoneType = action.payload.data.data;
      })
      .addCase(fetchGroupUom.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGroupUom.fulfilled, (state, action) => {
        state.loading = false;
        state.dataGroupUom = action.payload.data.data;
      })
      .addCase(fetchGroup1.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGroup1.fulfilled, (state, action) => {
        state.loading = false;
        state.dataGroup1 = action.payload.data.data;
      })
      .addCase(fetchGroup2.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGroup2.fulfilled, (state, action) => {
        state.loading = false;
        state.dataGroup2 = action.payload.data.data;
      })
      .addCase(fetchGroup3.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGroup3.fulfilled, (state, action) => {
        state.loading = false;
        state.dataGroup3 = action.payload.data.data;
      });
    // .addCase(removeById.pending, (state) => {
    //   state.loading = true;
    // })
    // .addCase(removeById.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.result = action.payload;
    // })
  },
});

export const { resetData, setSelected } = businessParameterSlice.actions;

export const selectParameter = (state) => state.businessParameter.data;
export const selectParameter2 = (state) => state.businessParameter.data2;
export const selectParameter3 = (state) => state.businessParameter.data3;
export const selectParameter4 = (state) => state.businessParameter.data4;
export const selectParameter5 = (state) => state.businessParameter.data5;
export const selectParameter6 = (state) => state.businessParameter.data6;
export const selectParameter7 = (state) => state.businessParameter.data7;
export const selectParameter8 = (state) => state.businessParameter.data8;
export const selectGroup = (state) => state.businessParameter.dataGroup;
export const selectIdParameter = (state) => state.businessParameter.dataId;
export const selectIdGroup = (state) => state.businessParameter.dataIdGroup;
export const selectLoading = (state) => state.businessParameter.loading;
export const selectError = (state) => state.businessParameter.error;
export const selectPageNo = (state) => state.businessParameter.pageNo;
export const selectPageSize = (state) => state.businessParameter.pageSize;
export const selectTotalRecord = (state) => state.businessParameter.totalRecord;
export const selectSelected = (state) => state.businessParameter.selected;
export const selectResult = (state) => state.businessParameter.result;
export const selectAreaFunc = (state) =>
  state.businessParameter.dataGroupAreaFunc;
export const selectCountry = (state) =>
  state.businessParameter.dataGroupCountry;
export const selectPhoneType = (state) =>
  state.businessParameter.dataGroupPhoneType;
export const selectUom = (state) => state.businessParameter.dataGroupUom;
export const selectGroup1 = (state) => state.businessParameter.dataGroup1;
export const selectGroup2 = (state) => state.businessParameter.dataGroup2;
export const selectGroup3 = (state) => state.businessParameter.dataGroup3;

export default businessParameterSlice.reducer;
